var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "camera_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.236 5.992a1 1 0 0 0-.894.553l-.724 1.447H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1.618l-.724-1.447a1 1 0 0 0-.894-.553h-3.528zM7.553 5.65a3 3 0 0 1 2.683-1.658h3.528a3 3 0 0 1 2.683 1.658l.171.342H17a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-8a4 4 0 0 1 4-4h.382l.17-.342z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.992a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
    fill: "currentColor"
  })));
};

export { SvgCamera as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjIzNiA1Ljk5MmExIDEgMCAwMC0uODk0LjU1M2wtLjcyNCAxLjQ0N0g3YTIgMiAwIDAwLTIgMnY4YTIgMiAwIDAwMiAyaDEwYTIgMiAwIDAwMi0ydi04YTIgMiAwIDAwLTItMmgtMS42MThsLS43MjQtMS40NDdhMSAxIDAgMDAtLjg5NC0uNTUzaC0zLjUyOHpNNy41NTMgNS42NWEzIDMgMCAwMTIuNjgzLTEuNjU4aDMuNTI4YTMgMyAwIDAxMi42ODMgMS42NThsLjE3MS4zNDJIMTdhNCA0IDAgMDE0IDR2OGE0IDQgMCAwMS00IDRIN2E0IDQgMCAwMS00LTR2LThhNCA0IDAgMDE0LTRoLjM4MmwuMTctLjM0MnoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIgMTUuOTkyYTIgMiAwIDEwMC00IDIgMiAwIDAwMCA0em0wIDJhNCA0IDAgMTAwLTggNCA0IDAgMDAwIDh6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";